/**
 * Market making management API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MarketMakingPairSetting } from './marketMakingPairSetting';

export interface MarketMakingPairStatus {
  pairSettingId?: number;
  pairSetting?: MarketMakingPairSetting;
  unhedgedLong?: number;
  unhedgedLongVolume?: number;
  unhedgedShort?: number;
  unhedgedShortVolume?: number;
  loss?: number;
  fixMessageCountRps?: number;
  lastActiveTime?: string;
}
